define('CustomProductCollection.UrlHelper', [], function CustomProductCollectionUrlHelper() {
    'use strict';

    /**
     * Utility functions for parsing and decoding URL parameters/options
     * in custom product collection modules.
     * Depends on underscore for some string operations.
     * @module CustomProductCollection.UrlHelper
     */

    /**
     * Decodes a URL parameter, handling percent encoding.
     * @param {string} urlParameterP
     * @returns {string}
     */
    function getDecodedURLParameter(urlParameterP) {
        var position;
        var temporal;
        var urlParameter;
        var extract;

        urlParameter = urlParameterP || '';
        temporal = '';

        // eslint-disable-next-line no-cond-assign
        for (
            ;
            (position = urlParameter.indexOf('%')) >= 0;
            urlParameter = urlParameter.substring(position + 3)
        ) {
            temporal += urlParameter.substring(0, position);
            extract = urlParameter.substring(position, position + 3);

            try {
                temporal += decodeURIComponent(extract);
            } catch (e) {
                temporal += extract;
            }
        }

        return temporal + urlParameter;
    }

    /**
     * Parses a URL options string into a key-value object.
     * Reduces cognitive complexity by splitting sub-steps.
     * @param {string} optionsString
     * @returns {Object}
     */
    function parseUrlOptions(optionsString) {
        var options = {};
        var query = '';
        var idxQ;
        var idxH;
        var tokens;
        var i;
        var pair;
        var key;
        var value;

        // Step 1: Extract query portion (remove fragments and leading URL parts)
        if (optionsString) {
            idxQ = optionsString.indexOf('?');
            idxH = optionsString.indexOf('#');
            if (idxQ !== -1) {
                // There is a '?', keep only what follows.
                query = optionsString.substring(idxQ + 1);
            } else {
                // No '?', work from the beginning.
                query = optionsString;
            }
            if (idxH !== -1) {
                // Remove fragment
                query = query.split('#')[0];
            }
        }

        if (query.length > 0) {
            tokens = query.split('&');
            for (i = 0; i < tokens.length; i++) {
                pair = tokens[i].split('=');
                key = pair[0];
                value = pair.length > 1 ? getDecodedURLParameter(pair[1]) : '';
                if (key) {
                    options[key] = value;
                }
            }
        }

        return options;
    }

    /**
     * @returns {Object} Utility API for custom product collection URL helpers
     */
    return {
        getDecodedURLParameter: getDecodedURLParameter,
        parseUrlOptions: parseUrlOptions
    };
});
